import { useMemo } from 'react'
import QR from 'qrcode'
import useAsync from '~/app/utils/useAsync'
import { sendKinesisLogOrderDetailQrCodeSuccess } from '~/app/kinesis/order-detail-page'

/**
 * useQrCode
 * author: soojin.oh
 */

// type definitions

// hook
const useQrCode = function (qrInfo?: string) {
  const convertQr = useMemo<Promise<string>>(
    () =>
      new Promise((resolve, reject) => {
        try {
          const qr =
            qrInfo &&
            QR.toDataURL(qrInfo || '', {
              margin: 0,
              width: 160,
              rendererOpts: {
                quality: 1,
              },
            })
          if (qr) {
            sendKinesisLogOrderDetailQrCodeSuccess(qrInfo as string, 'Y')
            resolve(qr)
          }
        } catch (e) {
          sendKinesisLogOrderDetailQrCodeSuccess(qrInfo ?? '', 'N')
          reject(e)
        }
      }),
    [qrInfo]
  )
  const [qrCode = ''] = useAsync(convertQr, err => void err)
  return [qrCode]
}

export default useQrCode
